// extracted by mini-css-extract-plugin
export var accountData = "auth-forms-module--account-data--3wcpH";
export var authForm = "auth-forms-module--auth-form--H8-Li";
export var button = "auth-forms-module--button--0GET3";
export var contactForm = "auth-forms-module--contactForm--IOFoK";
export var input = "auth-forms-module--input--dQm61";
export var linkPass = "auth-forms-module--linkPass--ed+wo";
export var newsletterForm = "auth-forms-module--newsletter-form--GMVCh";